import styled from 'styled-components'
import { colors, Typography } from '../../style'

export const HotWeatherWarningContainer = styled.div`
  background: ${colors.BACKGROUND_GREY};
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 20px;
`
export const HotWeatherWarningSection = styled.section`
  box-shadow: 0 1px 3px 0 rgba(34, 36, 78, 0.2), 0 2px 2px 0 rgba(34, 36, 78, 0.12), 0 0 2px 0 rgba(34, 36, 78, 0.14);
  padding: 20px 0;
  background: ${colors.COLOUR_WHITE};
`
export const HotWeatherWarningH2Text = styled(Typography.H2)<{ flushBottom?: boolean }>`
  font-weight: 800;
  line-height: 1.5;
  margin: ${(p) => (p.flushBottom ? '0 15px' : '0 15px 24px 15px')};
`

export const HotWeatherWarningHeaderText = styled(Typography.H3)<{flushBottom?: boolean}>`
  font-weight: 800;
  line-height: 1.5;
  margin: ${(p) => p.flushBottom ? '15px' : '15px'};
`
export const HotWeatherWarningParagraph = styled(Typography.Body)<{flushTop?: boolean}>`
  color: ${colors.TERTIARY_CHARCOAL_140};
  margin: ${(p) => p.flushTop ? '0 15px 12px' : '12px 15px'};
`
